import { Injectable } from '@angular/core';
import { GanttConfigService, GanttGlobalConfig } from '@worktile/gantt';
import dayjs from 'dayjs';
import 'dayjs/locale/en';

@Injectable()
export class CustomGanttConfigService extends GanttConfigService {
  constructor() {
    // 👇 force dayjs to use English globally
    dayjs.locale('en');

    const customConfig: GanttGlobalConfig = {
      locale: 'en',          // keep string for fallback
      dateFormat: 'MMM',     // Jan, Feb, Mar
      showTodayLine: true,
      weekendHighlight: true
    } as any;

    super(customConfig);
  }
}
